export default {
  tag: 'Test',
  tag_tooltip: 'Test restaurant: fully working, never billed.',
  card: {
    title: 'Test restaurant',
    description:
      'Mark one restaurant as your test restaurant to try printing, e-mails, orders and integrations in production. It works like any other restaurant and is never billed. Customer e-mails and SMS about its orders start with [TEST].',
    payments_note:
      'Payments at the test restaurant are real and paid out like any other. Refund test orders yourself. We are notified when its monthly sales grow beyond testing.',
    designated_on: 'Marked as test on {{date}}',
    open_shop: 'Open shop',
    remove: 'Remove Test designation',
    select_placeholder: 'Choose a restaurant',
    mark: 'Mark as test restaurant',
    no_restaurants: 'You have no restaurant to mark yet.',
    load_error: 'Your test restaurant could not be loaded.',
  },
  remove_confirm: {
    title: 'Remove the Test designation from {{name}}?',
    description_live:
      'Billing for this restaurant resumes, and it goes offline right away. Relaunch it from Order settings → Order Methods → Live orders, where you choose its plan.',
    description_stays_live: 'This restaurant stays live and is treated like your other restaurants again from now on.',
    description_offline:
      'Billing for this restaurant resumes once it goes live. Its plan is chosen when you launch it.',
    confirm: 'Remove Test designation',
  },
  toasts: {
    designated: '{{name}} is now your test restaurant. It is not billed.',
    designate_error: 'The restaurant could not be marked as test. Please try again.',
    removed: '{{name}} is no longer your test restaurant.',
    removed_offline: '{{name}} is no longer your test restaurant and is now offline.',
    remove_error: 'The Test designation could not be removed. Please try again.',
  },
};
